<template>
  <div class="left-menu">
    <div v-for="item in menuList" :key="item.path">
      <!--一级菜单-->
      <div
          v-if="!item.children"
          class="menu-item"
          :class="{ active: $route.path === item.path }"
          @click="goTo(item.path)"
      >
        {{ getItemName(item.key) }}
      </div>

      <!--带子菜单的一级菜单：口腔癌术后康复课程-->
      <div v-else class="parent-menu">
        <div class="menu-item parent-title" @click="toggleSub(item)">
          {{ getItemName(item.key) }}
          <span class="arrow">{{ item.open ? '▼' : '▶' }}</span>
        </div>
        <!--子菜单组-->
        <div v-show="item.open" class="sub-menu-wrap">
          <div
              v-for="sub in item.children"
              :key="sub.path"
              class="sub-menu-item"
              :class="{ active: $route.path === sub.path }"
              @click="goTo(sub.path)"
          >
            {{ getItemName(sub.key) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftMenuTree',
  data() {
    return {
      // 不再写死name，改用key关联main.js中的i18n字典
      menuList: [
        { key: 'home', path: '/home' },
        {
          key: 'courseTitle',
          open: true, //默认展开
          children: [
            {
              key: 'lesson1',
              path: '/course/basic'
            },
            {
              key: 'lesson2',
              path: '/course/acute'
            },
            {
              key: 'lesson3',
              path: '/course/subacute'
            },
            {
              key: 'lesson4',
              path: '/course/homeRehab'
            }
          ]
        },
        { key: 'vpPage', path: '/virtualPatient' },
        { key: 'discussion', path: '/discussion' },
        { key: 'about', path: '/about' }
      ]
    }
  },
  methods: {
    getItemName(key){
      return this.$i18n[key]
    },
    //展开折叠子菜单
    toggleSub(item) {
      item.open = !item.open
    },
    goTo(path) {
      // 如果点击的是当前已经处于的路由，直接返回，不做跳转，消除重复导航报错
      if(this.$route.path === path){
        return
      }
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.left-menu {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e4e7ed;
  padding-top: 12px;
}
.menu-item {
  padding: 12px 20px;
  cursor: pointer;
  border-left: 3px solid transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menu-item:hover {
  background: #f5f7fa;
}
.menu-item.active {
  background: #ecf5ff;
  border-left-color: #409eff;
  color: #409eff;
}
.parent-title{
  background:#fafafa;
}
.sub-menu-wrap{
  background:#f7f8fa;
}
.sub-menu-item {
  padding:10px 32px;
  cursor: pointer;
}
.sub-menu-item:hover {
  background:#eef1f6;
}
.sub-menu-item.active {
  color:#409eff;
  background:#ecf5ff;
}
.arrow{
  font-size:12px;
  color:#666;
}
</style>
